import React, {useState, useEffect} from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema';
import { useDispatch, useSelector } from 'react-redux';
import { loadMunicipios, storeMunicipio } from '~/store/modules/municipio/action';

const Create = () => {
  let history = useHistory();
  const { estado_id } = useParams();
  const [municipio, setMunicipio] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ MunicipioReducer }) => MunicipioReducer);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.save) {
      setSaved(errors.save);
    }
  }, [errors]);

  useEffect(() => {
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Município criado com sucesso!', 'success').then(
        () => {
          history.push(`/estado/${estado_id}/detalhe`);
          dispatch(loadMunicipios(estado_id))
        }
      );
    }
  }, [status_response, history, dispatch, estado_id, saved]);


  const handleClose = () => {
    history.push(`/estado/${estado_id}/detalhe`);
    dispatch(loadMunicipios(estado_id));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(municipio)) {
      let yup_errors = {};
      schema.validate(municipio, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      municipio.estado_id = estado_id;
      await dispatch(storeMunicipio(municipio));
    }
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">  Município</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title"> <FaPlus/> Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              municipio={municipio}
              schema={schema}
              setMunicipio={setMunicipio}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link
          className="btn btn-default"
          to={`/estado/${estado_id}/detalhe`}
        >
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button
          className="btn btn-success"
          form="form_municipio"
          type="submint"
        > <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
